// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"styles_tableWrap__2Dm24"};